export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44b7a84ffd06759c1a1e2'
  }
};

export const QUERY = `
  mutation invoicesRemove ($filter: AutoFilledFilterRemoveOneinvoicesInput!, $sort: SortRemoveOneinvoicesInput) {
    invoicesRemove (filter: $filter, sort: $sort) {
        recordId
        record {
            companyId
            customerId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            bkInvoice
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
